import React from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import FacebookIcon from '@material-ui/icons/Facebook';

const SocialBtns = ({ handleChange, view, classes }) => {
  return (
    <div>
      <ToggleButtonGroup
        orientation="vertical"
        value={view}
        exclusive
        onChange={handleChange}
        size="small"
        classes={{ grouped: classes.toggle }}
      >
        <ToggleButton name="Twitter" value="twitter" aria-label="twitter">
          <TwitterIcon fontSize="small" />
        </ToggleButton>
        <ToggleButton name="Linkedin" value="linkedin" aria-label="linkedin">
          <LinkedInIcon fontSize="small" />
        </ToggleButton>
        <ToggleButton name="Facebook" value="facebook" aria-label="facebook">
          <FacebookIcon fontSize="small" />
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default SocialBtns;
